import React, { useEffect, useState } from 'react';
import { Form, Input, InputNumber, DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import { UseFetchListEnum } from '../../../../hooks/useFetchEnums';
import { ENUM_TYPE } from '../../../../data/constant';

const { Option } = Select;

// Group options: 0 = ไม่เข้า, 1 = เข้า
const GROUP_OPTIONS = [
  { value: 0, label: 'ไม่เข้า' },
  { value: 1, label: 'เข้า' },
];

function FormVIP({ formRef, onFinish, initialValues = {} }) {
  const { mutateAsync: listEnum } = UseFetchListEnum();
  const [loading, setLoading] = useState(false);
  const [rankOptions, setRankOptions] = useState([]);

  useEffect(() => {
    getEnums();
  }, []);

  const getEnums = async () => {
    try {
      setLoading(true);
      const result = await listEnum({
        enumType: [ENUM_TYPE.vip_rank],
      });
      setLoading(false);

      // Filter VIP rank options (type = 5)
      const vipRankOptions = result
        .filter((item) => item.type === ENUM_TYPE.vip_rank)
        .map((item) => ({
          value: item.value,
          label: item.label,
        }));
      setRankOptions(vipRankOptions);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // Convert startDate to dayjs if exists
  const formattedInitialValues = {
    ...initialValues,
    startDate: initialValues.startDate ? dayjs(initialValues.startDate) : null
  };

  return (
    <Form
      name="FormVIP"
      ref={formRef}
      layout="vertical"
      onFinish={onFinish}
      initialValues={formattedInitialValues}
    >
      <div className='mt-5 grid lg:gap-x-5 lg:grid-cols-2'>
        <Form.Item
          className='block mb-2 text-sm font-medium text-gray-700'
          name="userId"
          label="User ID"
          rules={[{ required: true, message: 'กรุณาระบุ User ID' }]}
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="User ID ของลูกค้า VIP"
          />
        </Form.Item>

        <Form.Item
          className='block mb-2 text-sm font-medium text-gray-700'
          name="prefix"
          label="Prefix"
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="Prefix"
          />
        </Form.Item>

        <Form.Item
          className='block mb-2 text-sm font-medium text-gray-700'
          name="name"
          label="ชื่อ-นามสกุล"
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="ชื่อลูกค้า"
          />
        </Form.Item>

        <Form.Item
          className='block mb-2 text-sm font-medium text-gray-700'
          name="nickName"
          label="ชื่อเล่น"
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="ชื่อเล่น"
          />
        </Form.Item>

        <Form.Item
          className='block mb-2 text-sm font-medium text-gray-700'
          name="rank"
          label="Rank"
        >
          <Select
            placeholder="เลือก Rank"
            allowClear
            loading={loading}
            options={rankOptions}
          />
        </Form.Item>

        <Form.Item
          className='block mb-2 text-sm font-medium text-gray-700'
          name="group"
          label="สถานะการเข้ากลุ่ม"
        >
          <Select
            placeholder="เลือกสถานะ"
            allowClear
            options={GROUP_OPTIONS}
          />
        </Form.Item>

        <Form.Item
          className='block mb-2 text-sm font-medium text-gray-700 lg:col-span-2'
          name="startDate"
          label="วันที่เริ่มต้น"
        >
          <DatePicker
            className="w-full"
            placeholder="เลือกวันที่"
            format="DD/MM/YYYY"
          />
        </Form.Item>
      </div>
    </Form>
  );
}

export default FormVIP;
